(() => {
	document.addEventListener("DOMContentLoaded", () => {
	  init();
	});
})();

const init = () => {
	banner();
	lineupObj();
	feedObj();
	productObj();
	anchorLink();
	accordionObj();
	modalObj();
}

const anchorLink = () => {
	const anchors = document.querySelectorAll('.btn-anchor');
	anchors.forEach(anchor => {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();
			const href = anchor.getAttribute('href');
			const target = document.querySelector(href);
			if (target) {
				const offset = 0; // 必要に応じてオフセットを調整
				const position = target.getBoundingClientRect().top + window.pageYOffset - offset;
				window.scrollTo({
					top: position,
					behavior: 'smooth'
				});
			}
		});
	});
}

const banner = () => {
	const handleScroll = () => {
		const bannarHeight = document.querySelector('#banner-area').clientHeight;
		const target = document.querySelector('#hero');
		const position = target.getBoundingClientRect().bottom + bannarHeight;
		const windowHeight = window.innerHeight;
		let body = document.body;

		if (position < windowHeight) {
			body.classList.add('js-on');
		} else {
			body.classList.remove('js-on');
		}
	};

	window.addEventListener('scroll', handleScroll);
	handleScroll(); // 初回読み込み時にも判定
}

const lineupObj = () => {
	if (document.querySelector('.lineup-list')) {
		var splide = new Splide( '.lineup-list.splide', {
			type: "loop",
			pagination: false,
			rewind: true,
			gap: '20px',
			padding: '40px',
			breakpoints: {
				389: {
					gap: '5.1282vw',
					padding: '10.2564vw',
				},
			  },
		});
		splide.mount();
	}
}

const feedObj = () => {
	if (document.querySelector('.feed-list')) {
		var splide = new Splide( '.feed-list.splide', {
			pagination: false,
			rewind: true,
			gap: '52px',
			padding: '52px',
			389: {
				gap: '13.3333vw',
				padding: '13.3333vw',
			},
		});
		splide.mount();
	}
}

const productObj = () => {
	if (document.querySelector('.product-list')) {
		var splide = new Splide( '.product-list.splide', {
			type: 'loop',
			pagination: false,
			focus: 'center',
			gap: '38px',
			padding: '38px',
			breakpoints: {
				389: {
					gap: '9.7436vw',
					padding: '9.6436vw',
				},
			},
		});
		splide.mount();
	}
}

const accordionObj = () => {
	const faqDts = document.querySelectorAll('.gohan #faq dt, .gohan #product dt');
	faqDts.forEach(dt => {
		dt.addEventListener('click', () => {
			dt.classList.toggle('js__on');
		});
	});
}

const modalObj = () => {
	if (document.querySelector('.btn_modal')) {
		$('.btn_modal').modaal();
	}
}
